export default __webpack_public_path__ + "static/media/Nunito-SemiBold.26690929.svg";